import { $themeBreakpoints } from '@themeConfig'
import agentService from '@/service/agentService'

export default {
  namespaced: true,
  state: {
    serverTime: null,
    windowWidth: 0,
    shallShowOverlay: false,
    userData: '',
    delegatedRightsRequestSequence: 0,
    delegatedRights: {
      canManagePoyDetails: false,
      canPoyDetailsCallback: false,
      canPoyDetailsApi: false,
    },
    toNumber: (() => {
      const commaRe = /\B(?=(\d{3})+(?!\d))/g
      const addCommas = s => {
        const dot = s.indexOf('.')
        if (dot === -1) return s.replace(commaRe, ',')
        return s.slice(0, dot).replace(commaRe, ',') + s.slice(dot)
      }
      return v => {
        if (v === null || v === undefined || v === '') return '0'
        if (typeof v === 'string') {
          const trimmed = v.trim()
          const num = parseFloat(trimmed)
          if (Number.isNaN(num)) return '0'
          if (trimmed.includes('.')) {
            const decimalPlaces = Math.min(trimmed.split('.')[1].length, 2)
            return addCommas((Math.round(num * 100) / 100).toFixed(decimalPlaces))
          }
          return addCommas(trimmed)
        }
        if (typeof v === 'number') {
          if (Number.isNaN(v)) return '0'
          return addCommas(String(Math.round(v * 100) / 100))
        }
        return '0'
      }
    })(),
    DateFormat: (d, startTime) => {
      const pad = n => (n < 10 ? '0' : '') + n
      if (startTime) {
        return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${startTime}`
      }
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    isMaster: store => store.state.app.userData.agent === 'master' || store.state.app.userData.username === 'master',
  },
  getters: {
    canManagePoyDetails: state => state.delegatedRights.canManagePoyDetails,
    canReadPoyDetailsDocs: state => state.delegatedRights.canPoyDetailsCallback
      || state.delegatedRights.canPoyDetailsApi,
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_DELEGATED_RIGHTS(state, val) {
      state.delegatedRightsRequestSequence += 1
      state.delegatedRights = {
        canManagePoyDetails: val.canManagePoyDetails === true,
        canPoyDetailsCallback: val.canPoyDetailsCallback === true,
        canPoyDetailsApi: val.canPoyDetailsApi === true,
      }
    },
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    UPDATE_USER_DATA(state, val) {
      state.userData = val
      state.delegatedRightsRequestSequence += 1
      state.delegatedRights = {
        canManagePoyDetails: false,
        canPoyDetailsCallback: false,
        canPoyDetailsApi: false,
      }
    },
  },
  actions: {
    async LOAD_DELEGATED_RIGHTS({ commit, state }) {
      commit('UPDATE_DELEGATED_RIGHTS', {})
      const sequence = state.delegatedRightsRequestSequence
      if (!state.userData) return
      try {
        const res = await agentService.getAuthen('agent-delegation/mine')
        if (sequence !== state.delegatedRightsRequestSequence) return
        commit('UPDATE_DELEGATED_RIGHTS', res.status === 200 ? res.data : {})
      } catch (error) {
        if (sequence === state.delegatedRightsRequestSequence) commit('UPDATE_DELEGATED_RIGHTS', {})
      }
    },
    LOAD_USER_DATA({
      commit,
      state,
    }) {
      commit('UPDATE_USER_DATA', JSON.parse(localStorage.getItem('userData')))
      return state.userData
    },
  },
}
